import { entryChannels } from '@/mocks/gossipData';

const tints = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-800',
  'bg-secondary-100 text-secondary-700',
];

export default function EntryBoard() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <span className="fade-up inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs font-medium text-foreground-600">
            <i className="ri-flashlight-line text-primary-600" />
            黑吃瓜 · 首页入口条
          </span>
          <h1 className="fade-up mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl" style={{ animationDelay: '60ms' }}>
            黑吃瓜
            <span className="block mt-2 text-foreground-800 md:mt-4">
              今天，又有谁的
              <span className="text-primary-600">瓜</span>
              在等你？
            </span>
          </h1>
          <p className="fade-up mt-5 text-base leading-relaxed text-foreground-600 md:text-lg" style={{ animationDelay: '120ms' }}>
            最新黑料速递每日在更，今日新料与猛料按圈子分棚摆好。
            不想错过黑吃瓜今日黑料的，从下面入口条进对应的瓜田即可。
          </p>
          <div className="fade-up mt-6 flex flex-wrap items-center justify-center gap-2" style={{ animationDelay: '180ms' }}>
            {['今日黑料速递', '持续更新', '按圈子浏览', '全网围观'].map((t) => (
              <span
                key={t}
                className="rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-800"
              >
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-12 flex items-center justify-between border-b border-background-200 pb-3">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
            <span className="h-5 w-1.5 rounded-full bg-accent-500" />
            今日瓜单 · 按圈子进棚
          </h2>
          <a href="#fresh" className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-700 cursor-pointer whitespace-nowrap">
            全部新料
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4 lg:grid-cols-3">
          {entryChannels.map((c, i) => (
            <a
              key={c.key}
              href="#topic"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-white p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/40 cursor-pointer"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tints[i % tints.length]} transition-transform group-hover:scale-105`}
              >
                <i className={`${c.icon} text-xl`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="font-semibold text-foreground-950">{c.name}</span>
                  <span className="rounded-md bg-primary-100 px-1.5 py-0.5 text-[10px] font-bold text-primary-700">
                    今日 +{c.count}
                  </span>
                </span>
                <span className="mt-1 block truncate text-xs text-foreground-500">{c.tagline}</span>
              </span>
              <span className="flex shrink-0 flex-col items-end gap-1">
                <span className="flex items-center gap-1 text-[10px] font-semibold text-accent-700 whitespace-nowrap">
                  <span className="pulse-dot inline-block h-1 w-1 rounded-full bg-accent-500" />
                  {c.state}
                </span>
                <i className="ri-arrow-right-line text-foreground-300 transition-colors group-hover:text-primary-600" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}